import React from 'react';

import Layout from '../components/Layout';

import { Link } from 'gatsby';
import Header from '../components/Header';
import Footer from '../components/Footer';

import pic1 from '../assets/images/pic01.jpg';
import pic2 from '../assets/images/pic02.jpg';
import pic3 from '../assets/images/pic03.jpg';
import pic4 from '../assets/images/CompassShot.png'
import pic5 from '../assets/images/PicInt.jpg'


const IndexPage = () => (
  <Layout>
    <Header />

    <div id="main">
      <header className="major container medium">
        <h2>
          Microsoft 365 Experts
          <br />
        &nbsp;to help you on your
          <br />
          &nbsp;journey in the
          <br />
          cloud
        </h2>
      </header>

      <div className="box alt container">
      <section className="feature left">
          <div className="image icon fa-signal">
            <img src={pic1} alt="" />
          </div>
          <div className="content">
            <h3>Microsoft 365 Guidence</h3>
            <p> 
                Since 2010 we have been helping companies adopt the cloud through guidence and education. Office 365, Teams, SharePoint, Dynamics, Power Platform, Office. 
            </p>
          </div>
        </section>
        <section className="feature right">
          <div  className="image icon fa-code">
            <img src={pic2} alt="" />
          </div>
          <div className="content">
            <h3>Custom Development</h3>
            <p>
Securly building custom solutions in the cloud is what we are good at. Web applications, SharePoint, Office Integrations, Microsoft Teams, Dynamics and more. 

            </p>
          </div>
        </section>
        
        <section className="feature left">
          <div className="image icon fa-compass">
            <img src={pic4} alt="" />
          </div>
          <div className="content">
            <h3>Compass - Management System</h3>
            <p>
A management system is usually central to any business. Our management system is build on top of the office 365 platform and allows the reuse of existing business investments.
            </p>
          </div>
        </section>
        <section className="feature right">
          <div className="image icon fa-cloud-upload">
            <img src={pic3} alt="" />
          </div>
          <div className="content">
            <h3>Migration</h3>
            <p>
Thinking about migrating to the cloud and need some help getting there?  
We have been migrating companies to the cloud ever since Office 365 became a thing. 
            </p>
          </div>
        </section>
        <section className="feature left">
          <div className="image icon fa-plug">
            <img src={pic5} alt="" />
          </div>
          <div className="content">
            <h3>Integration</h3>
            <p>
            Getting systems to talk together can be tricky business. We can help. Hybrid integrations and other types of integrations of system in the cloud.  
            </p>
          </div>
        </section>
      </div>

      <footer className="major container medium">
        {/* <h3>Get shady with this starter</h3>
        <p>
          There is also elements page in this template. Click below button to
          check
        </p>
        <ul className="actions special">
          <li>
            <Link to="/Elements" className="button">
              View Elements
            </Link>
          </li>
        </ul> */}
      </footer>
    </div>
    <Footer />
  </Layout>
);

export default IndexPage;
